import type { FaireProductEntity } from "../../entity_types/product";

export const p_hakhzqbghs: FaireProductEntity = {
  token: "p_hakhzqbghs",
  type: "product",
  name: "Sunwarrior Active Nighttime Capsules - Sleep & Restore",
  brandToken: "b_4ce3l13q1j",
  brandName: "Sunwarrior",
  imageUrl:
    "https://cdn.faire.com/fastly/ff9eb54b395a7b25c712b025f17e7d0af58e07cdb1f468aa39c6a120db804ca2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7462b5657740f8eac06b6b8b2b82d323dd4a3e7be6bf4af8e9b3b363214508c1.png",
    "https://cdn.faire.com/fastly/3c0b434a5852bca0f1d8344fe8a78f31b69316cfa810e654331fbf1d183714d3.png",
    "https://cdn.faire.com/fastly/22cd7a012e4408ff98af2e314c034aaee1df04e19376fa835359e38c2521579b.png",
    "https://cdn.faire.com/fastly/d5c11dd1e6f2bf655ad8858481e4d7341ff7cd800eb179e8873511ac77102d84.png",
    "https://cdn.faire.com/fastly/ff1d193ce64c79de8661cc77adb3c871e4fc82a02f9fa5f6e71d7119b6eeb3d1.png",
    "https://cdn.faire.com/fastly/d20b3569cde0f090f5d63faaff446d6e71304ee9c46dc819989f1966d04d3c65.png",
    "https://cdn.faire.com/fastly/3018bbf20e28dc740ad901f130fe8904ca359188f0cdafd36729c227cf9e6c80.png",
    "https://cdn.faire.com/fastly/0e4e505789898837f8b9e107e28b006bfb36f5f4e8ccede7eb1ce6c1a983025e.png",
    "https://cdn.faire.com/fastly/dc6d465b1350885e95ee021277aaddecdc52d737ea1ba1b25df42c5cf3c5c624.png",
    "https://cdn.faire.com/fastly/b650bc1c1b57f21f2b76fecf4d7f0a0f0ebc0a7f824360cd084ceb9db69745de.png",
    "https://cdn.faire.com/fastly/c908b1b131b8621dc7b85b3178c811d0a7893764df1490905a6a89c06d24d7a8.png",
  ],
  priceDollars: 23.99,
  description:
    "Unwind, recharge, and wake up refreshed with Sunwarrior Active Nighttime Capsules. This melatonin-free formula is packed with calming herbs, adaptogens, and recovery-supporting ingredients to promote deep, restful sleep without grogginess. Designed for active lifestyles, it helps soothe sore muscles, enhance recovery, and bring balance to your nights—so you can power through your days.\n\n • Supports Restful Sleep – Fall asleep naturally without melatonin\n • Enhances Recovery – Reduces soreness from workouts or daily activity\n • Promotes Relaxation – Adaptogens and calming herbs ease stress and tension\n • Wake Up Refreshed – No grogginess or sluggish mornings\n • Clean & Plant-Based – Vegan, soy-free, gluten-free, and dairy-free\n\nSleep better, recover faster, and feel your best—night after night!",
  tags: [],
  msrpDollars: 39.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:54.820Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
